module.exports = __webpack_public_path__ + "img/empty.75548094.png";